import * as React from "react";

function FolderUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M448 96H275.9l-49.2-45.25C214.7 38.74 198.5 32 181.5 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h384c35.35 0 64-28.66 64-64V160c0-35.3-28.7-64-64-64zm16 320c0 8.824-7.178 16-16 16h-65.61c-7.69-45.4-46.89-80-94.39-80h-64c-47.54 0-86.73 34.64-94.39 80H64c-8.822 0-16-7.176-16-16V96c0-8.824 7.178-16 16-16h117.5c4.273 0 8.293 1.664 11.31 4.688L256 144h192c8.822 0 16 7.176 16 16v256zM256 192c-35.3 0-64 28.7-64 64 0 35.34 28.65 64 64 64s64-28.66 64-64c0-35.3-28.7-64-64-64z"
  }));
}

const ForwardRef = React.forwardRef(FolderUserIcon);
export default ForwardRef;